import { OneDeleteCommentDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useDeleteCommentActionResolver: OneCreationActionResolver = () => {
  const [deleteComment, { loading }] = useMutation(OneDeleteCommentDocument, {
    extractorFn: (data) => data.postsMutations.deletePostsComment,
    errorPolicy: 'all',
  })

  const deleteCommentHandler = async (args: { id: string; postId: string }) => {
    const result = await deleteComment({
      variables: {
        id: args.id,
        postId: args.postId,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: deleteCommentHandler,
    loading,
  }
}

export const DeleteCommentAction: OneCreateAction = {
  actionResolver: useDeleteCommentActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
